export enum PaymentType {
    TranferenciaItau = 1,
    OP = 2,
    TED = 3,
    Cheque = 4,
    PIX = 5
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/PaymentType.ts